import React from "react";
import { useSeller, useUser } from "../../hooks/useAccount";
import { SupportItem } from "./SupportItem";

export const SellerInfo = () => {
    const user = useUser();
    const seller = useSeller();
    return (
        <>
            <SupportItem
                name="Seller"
                copyText={`${seller.name} ${seller.id}`}
                value={<Line primary={seller.name} secondary={seller.id} />}
            />
            {user.id !== seller.id && (
                <SupportItem
                    name="User"
                    copyText={`${user.name} ${user.email}`}
                    value={<Line primary={user.name} secondary={user.email} />}
                />
            )}
        </>
    );
};

const Line = ({ primary, secondary }: { primary: string; secondary: string }) => {
    return (
        <span>
            {primary}
            <span className="pl-1 text-gray-dark">({secondary})</span>
        </span>
    );
};
